var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472,96H40c-22.056,0-40,17.944-40,40v240c0,22.056,17.944,40,40,40h432c22.056,0,40-17.944,40-40V136 C512,113.944,494.056,96,472,96z M496,376c0,13.234-10.766,24-24,24H40c-13.234,0-24-10.766-24-24V136c0-13.234,10.766-24,24-24 h432c13.234,0,24,10.766,24,24V376z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,216c22.056,0,40-17.944,40-40c0-3.383-0.424-6.747-1.262-9.998c-1.101-4.278-5.461-6.854-9.742-5.752 c-4.278,1.102-6.854,5.463-5.752,9.742c0.501,1.948,0.756,3.97,0.756,6.008c0,13.233-10.767,24-24,24s-24-10.767-24-24 s10.767-24,24-24c2.042,0,4.069,0.256,6.022,0.76c4.278,1.105,8.641-1.469,9.745-5.747c1.104-4.278-1.469-8.641-5.747-9.745 C86.762,136.426,83.391,136,80,136c-22.056,0-40,17.944-40,40S57.944,216,80,216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,184h24c4.418,0,8-3.582,8-8s-3.582-8-8-8h-24c-4.418,0-8,3.582-8,8S139.582,184,144,184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,184h104c4.418,0,8-3.582,8-8s-3.582-8-8-8H200c-4.418,0-8,3.582-8,8S195.582,184,200,184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,240H296c-4.418,0-8,3.582-8,8s3.582,8,8,8h160c4.418,0,8-3.582,8-8S460.418,240,456,240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,272H224c-4.418,0-8,3.582-8,8s3.582,8,8,8h232c4.418,0,8-3.582,8-8S460.418,272,456,272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,312c0,4.418,3.582,8,8,8h104c4.418,0,8-3.582,8-8s-3.582-8-8-8H88C83.582,304,80,307.582,80,312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,304c-2.11,0-4.17,0.85-5.66,2.34C48.85,307.83,48,309.89,48,312c0,2.11,0.85,4.17,2.34,5.66 C51.83,319.15,53.9,320,56,320c2.11,0,4.17-0.85,5.66-2.34c1.49-1.49,2.34-3.55,2.34-5.66c0-2.11-0.85-4.17-2.34-5.66 C60.17,304.85,58.11,304,56,304z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,336c-2.1,0-4.17,0.85-5.66,2.34C48.85,339.83,48,341.89,48,344c0,2.11,0.85,4.17,2.34,5.66 C51.83,351.15,53.9,352,56,352c2.11,0,4.17-0.85,5.66-2.34C63.15,348.17,64,346.1,64,344c0-2.1-0.85-4.17-2.34-5.66 C60.17,336.85,58.1,336,56,336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,336H88c-4.418,0-8,3.582-8,8s3.582,8,8,8h160c4.418,0,8-3.582,8-8S252.418,336,248,336z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessCard);
export default __webpack_public_path__ + "static/media/business-card.2a800bb2547d6675b525be1c5e924812.svg";
export { ForwardRef as ReactComponent };